import React, { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { useMediaQuery } from "react-responsive"
import { Link, useLocation } from "react-router-dom"

export default function Header({
    isDropdownOpen,
    setIsDropdownOpen,
    selectedOption,
    setSelectedOption,
    selectedCategory,
    setSelectedCategory,
}) {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    const getRandomRotation = () => (Math.random() < 0.5 ? 45 : -45)
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const [infoHovered, setInfoHovered] = useState(false);
    const [sortHovered, setSortHovered] = useState(false);
    const [homeHovered, setHomeHovered] = useState(false);
    
    return (
        <div style={{ position: "relative" }}>
            <header
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "20px",
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                }}
            >
                <motion.div 
                    whileHover={{ 
                        scale: 1.2, 
                        transition: { duration: 0.2 }
                    }}
                    style={{ marginLeft: isMobile ? "10px" : "40px" }}
                >
                    <Link to="/">
                        <img
                            src="/images/logo26.png"
                            alt="Logo"
                            style={{ height: isMobile ? "72px" : "144px" }}
                        />
                    </Link>
                </motion.div>
                <div style={{ flex: 1 }}></div>
                {/* Nav pill — always visible */}
                <div style={{ display: "flex", alignItems: "center", gap: isMobile ? "10px" : "16px" }}>

                    {/* Single unified pill: HOME (non-home) | INFO (non-info) | SORT (home only) */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "stretch",
                            border: "1.5px solid black",
                            borderRadius: "999px",
                            overflow: "hidden",
                            userSelect: "none",
                        }}
                    >
                        {/* HOME segment — shown on all non-home pages */}
                        {!isHomePage && (
                            <Link
                                to="/"
                                onMouseEnter={() => setHomeHovered(true)}
                                onMouseLeave={() => setHomeHovered(false)}
                                style={{
                                    color: homeHovered ? "white" : "black",
                                    backgroundColor: homeHovered ? "black" : "transparent",
                                    textDecoration: "none",
                                    fontFamily: "Fanwood, serif",
                                    fontSize: isMobile ? "11px" : "15px",
                                    letterSpacing: "0.1em",
                                    textTransform: "uppercase",
                                    padding: isMobile ? "7px 14px" : "12px 28px",
                                    borderRight: location.pathname !== "/info" ? "1.5px solid black" : "none",
                                    display: "flex",
                                    alignItems: "center",
                                    transition: "background-color 0.2s ease, color 0.2s ease",
                                }}
                            >
                                Home
                            </Link>
                        )}

                        {/* INFO segment — hidden on /info page */}
                        {location.pathname !== "/info" && (
                            <Link
                                to="/info"
                                onMouseEnter={() => setInfoHovered(true)}
                                onMouseLeave={() => setInfoHovered(false)}
                                style={{
                                    color: infoHovered ? "white" : "black",
                                    backgroundColor: infoHovered ? "black" : "transparent",
                                    textDecoration: "none",
                                    fontFamily: "Fanwood, serif",
                                    fontSize: isMobile ? "11px" : "15px",
                                    letterSpacing: "0.1em",
                                    textTransform: "uppercase",
                                    padding: isMobile ? "7px 14px" : "12px 28px",
                                    borderRight: isHomePage ? "1.5px solid black" : "none",
                                    display: "flex",
                                    alignItems: "center",
                                    transition: "background-color 0.2s ease, color 0.2s ease",
                                }}
                            >
                                Info
                            </Link>
                        )}

                        {/* SORT segment — home page only */}
                        {isHomePage && (
                            <button
                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                onMouseEnter={() => setSortHovered(true)}
                                onMouseLeave={() => setSortHovered(false)}
                                aria-expanded={isDropdownOpen}
                                aria-haspopup="true"
                                aria-label={`Sort projects ${isDropdownOpen ? "menu, expanded" : "menu, collapsed"}`}
                                style={{
                                    background: sortHovered ? "black" : "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: isMobile ? "6px" : "10px",
                                    padding: isMobile ? "7px 14px" : "12px 28px",
                                    fontFamily: "Fanwood, serif",
                                    fontSize: isMobile ? "11px" : "15px",
                                    letterSpacing: "0.1em",
                                    textTransform: "uppercase",
                                    color: sortHovered ? "white" : "black",
                                    transition: "background-color 0.2s ease, color 0.2s ease",
                                }}
                            >
                                Sort
                                <motion.svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    aria-hidden="true"
                                    animate={{ rotate: isDropdownOpen ? 45 : 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <line x1="6" y1="1" x2="6" y2="11" />
                                    <line x1="1" y1="6" x2="11" y2="6" />
                                </motion.svg>
                            </button>
                        )}
                    </div>

                </div>
            </header>

            <AnimatePresence>
                {isDropdownOpen && isHomePage && (
                    <motion.div
                        initial={{ opacity: 0, y: -8, scale: 0.97 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -8, scale: 0.97 }}
                        transition={{ duration: 0.22, ease: "easeOut" }}
                        style={{
                            position: "absolute",
                            top: "116px",
                            right: isMobile ? "10px" : "20px",
                            left: isMobile ? "10px" : "auto",
                            zIndex: 100,
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: "stretch",
                            border: "1.5px solid black",
                            borderRadius: isMobile ? "16px" : "999px",
                            backgroundColor: "#FFFFFF",
                            overflow: "visible",
                        }}
                    >
                        {/* DATE group */}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "6px",
                                padding: isMobile ? "12px 16px" : "14px 28px",
                                borderRight: isMobile ? "none" : "1.5px solid black",
                                borderBottom: isMobile ? "1.5px solid black" : "none",
                            }}
                        >
                            <span style={{
                                fontSize: "9px",
                                fontFamily: "Fanwood, serif",
                                textTransform: "uppercase",
                                letterSpacing: "0.14em",
                                opacity: 0.4,
                                color: "black",
                            }}>
                                Date
                            </span>
                            <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                                {[
                                    { label: "New to Old", value: "newToOld" },
                                    { label: "Old to New", value: "oldToNew" },
                                ].map(({ label, value }) => (
                                    <motion.div
                                        key={value}
                                        onClick={() => setSelectedOption(value)}
                                        whileHover={{ opacity: 0.7 }}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div style={{
                                            width: "8px",
                                            height: "8px",
                                            borderRadius: "50%",
                                            border: "1.5px solid black",
                                            backgroundColor: selectedOption === value ? "black" : "transparent",
                                            flexShrink: 0,
                                            transition: "background-color 0.15s ease",
                                        }} />
                                        <span style={{
                                            color: "black",
                                            fontSize: "12px",
                                            fontFamily: "Fanwood, serif",
                                            letterSpacing: "0.06em",
                                            textTransform: "uppercase",
                                            fontWeight: selectedOption === value ? "bold" : "normal",
                                        }}>
                                            {label}
                                        </span>
                                    </motion.div>
                                ))}
                            </div>
                        </div>

                        {/* CATEGORY group */}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "6px",
                                padding: isMobile ? "12px 16px" : "14px 28px",
                            }}
                        >
                            <span style={{
                                fontSize: "9px",
                                fontFamily: "Fanwood, serif",
                                textTransform: "uppercase",
                                letterSpacing: "0.14em",
                                opacity: 0.4,
                                color: "black",
                            }}>
                                Category
                            </span>
                            <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                                {[
                                    { label: "All", value: "" },
                                    { label: "Apparel", value: "apparel" },
                                    { label: "Footwear", value: "footwear" },
                                    { label: "Accessories", value: "accessories" },
                                ].map(({ label, value }) => (
                                    <motion.div
                                        key={value}
                                        onClick={() => setSelectedCategory(value)}
                                        whileHover={{ opacity: 0.7 }}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div style={{
                                            width: "8px",
                                            height: "8px",
                                            borderRadius: "50%",
                                            border: "1.5px solid black",
                                            backgroundColor: selectedCategory === value ? "black" : "transparent",
                                            flexShrink: 0,
                                            transition: "background-color 0.15s ease",
                                        }} />
                                        <span style={{
                                            color: "black",
                                            fontSize: "12px",
                                            fontFamily: "Fanwood, serif",
                                            letterSpacing: "0.06em",
                                            textTransform: "uppercase",
                                            fontWeight: selectedCategory === value ? "bold" : "normal",
                                        }}>
                                            {label}
                                        </span>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}